import React from "react"
import { Container, useMediaQuery } from "@material-ui/core"
import clsx from "clsx"
import Button from "@material-ui/core/Button"
import * as styles from "./fourBlocks.module.scss"
import { variantConfig } from "./variants"
import scrollToPersonalForm from "../../../helpers/scrollToPersonalForm"
import { DLClickEventExtended } from "../../../helpers/WatcherDL/DLEvents"

type FourBlocksProps = {
  orderNum: string
  dataVariant: "download"
  headTitle: string | JSX.Element
  styleVariant: "base"
}

export const FourBlocks = ({ dataVariant, orderNum, headTitle, styleVariant }: FourBlocksProps) => {
  const data = variantConfig[dataVariant]
  const isDesktop = useMediaQuery("(min-width:1279.95px)")

  const handleClick = (buttonText: string) => {
    DLClickEventExtended({
      name: buttonText,
      eventAction: "Множество преимуществ",
      placement: "benefits",
    })

    scrollToPersonalForm()
  }

  return (
    <div data-exclude={orderNum}>
      <Container className={clsx(styles.container, styleVariant && styles[styleVariant])}>
        {headTitle && <h2 className={styles.headTitle}>{headTitle}</h2>}

        <div className={styles.cardList}>
          {data.map(({ title, description, Icon, alt, buttonText }) => (
            <div className={styles.card}>
              <div className={styles.textBlock}>
                {title && <h3 className={styles.title}>{title}</h3>}
                {description && <p className={styles.description}>{description}</p>}
              </div>
              {buttonText && isDesktop && (
                <Button
                  disableRipple
                  onClick={() => handleClick(buttonText)}
                  className={clsx(styles.btn)}
                >
                  {buttonText}
                </Button>
              )}
              {Icon && <Icon className={styles.img} alt={alt} />}
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}
